import { FilterIcon } from "@heroicons/react/outline";
import { useDispatch } from "react-redux";
import { createDiscussionSliceActions } from "../../redux/features/Modal/createDiscussionSlice";

const HomePageNoRoom = () => {
  const dispatch = useDispatch();

  const openModal = () => {
    dispatch(createDiscussionSliceActions.enebleModal());
  };
  return (
    <div className="px-4 lg:px-0 flex flex-col space-y-5">
      <div className="flex justify-between items-center">
        <h1 className="text-xl">My Discussin Rooms</h1>
        <div className="flex items-center space-x-2">
          <FilterIcon className="h-6" />
          <p>Filter</p>
        </div>
      </div>
      <div className="bg-white rounded-md shadow">
        <div className="flex justify-center pt-10">
          <img src="/images/Empty.png" alt="imagess" className="h-16" />
        </div>
        <div className="flex flex-col space-y-4 lg:px-20 text-center py-3">
          <h1 className="text-xl font-semibold">
            You'r not part any Discussion Yet
          </h1>
          <p className="text-sm font-thin">
            You can create you'r own discussion or find relevent rooms by
            browsing through our recommended rooms page
          </p>
        </div>

        <div className="flex justify-center space-x-5 pt-5 pb-8">
          <button
            onClick={openModal}
            className="text-sm hover:shadow-md border focus:outline-none outline-none text-green-700 border-green-800 px-5 py-3 shadow rounded-md uppercase"
          >
            Create discussion
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomePageNoRoom;
